import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, ENVIRONMENT, TokenService } from '@cfp/core';
import { LoginCard, LoginLayout } from '@cfp/shared/ui/login';
import { LoadingSpinner } from '@cfp/ui/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoginTokenDTO, PiraeusSsoLoginService } from 'csr-login-app';

@Component({
  selector: 'cfp-piraeus-sso-authentication-page',
  templateUrl: './piraeus-sso-authentication-page.html',
  imports: [LoginLayout, LoginCard, LoadingSpinner, TranslateModule]
})
export class PiraeusSsoAuthenticationPage implements OnInit {
  protected loading: boolean = true;
  protected errorMessage: string;

  private readonly environment = inject(ENVIRONMENT);
  private readonly piraeusSsoLoginService = inject(PiraeusSsoLoginService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly tokenService = inject(TokenService);

  public ngOnInit(): void {
    this.piraeusSsoLoginService.piraeusSsoLoginInternalPost().subscribe({
      next: (response: LoginTokenDTO) => {
        this.tokenService.setToken(response['access_token']);
        this.authService.goToApp();
      },
      error: () => {
        this.loading = false;
        this.errorMessage = 'error.sso.couldNotLogin';
      }
    });
  }

  protected closeWindow(): void {
    if (window.opener) {
      window.close();
    } else {
      this.router.navigateByUrl(this.environment.loginRoute);
    }
  }
}
